import { useEffect, useRef } from "react";
import { formatThreadTimeLabel } from "./ThreadTimeLabel.logic";

/** Only the label ticks; neither the thread row nor the sidebar rerenders each second. */
export function ThreadTimeLabel({
  at,
  mode,
}: {
  at: string;
  mode: "working" | "snoozed" | "settled";
}) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const update = () => {
      if (ref.current) ref.current.textContent = formatThreadTimeLabel(at, mode, Date.now());
    };
    update();
    const timer = setInterval(update, mode === "working" ? 1000 : 60_000);
    return () => clearInterval(timer);
  }, [at, mode]);
  return (
    <span ref={ref} className="tabular-nums" title={at}>
      {formatThreadTimeLabel(at, mode, Date.now())}
    </span>
  );
}
